import { render } from "./TextReaderRegion.vue?vue&type=template&id=4f08ea08"
import script from "./TextReaderRegion.vue?vue&type=script&lang=js"
export * from "./TextReaderRegion.vue?vue&type=script&lang=js"

import "./TextReaderRegion.vue?vue&type=style&index=0&id=4f08ea08&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__